import script from "./ViewVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewVideo.vue?vue&type=script&setup=true&lang=ts"

import "./ViewVideo.vue?vue&type=style&index=0&id=2c3a2307&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3a2307"]])

export default __exports__